import { Accordion } from '@navi/web-ui/lib/primitives';
import { useState } from 'react';
import FeedbackItemHeader from './FeedbackItemHeader';
import FeedbackItemBody from './AddressFeedbackItemBody';
import { IFeedback } from '../interfaces';

const FeedbackAccordion = (props: { feedback: IFeedback }) => {
  const { feedback } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpansion = (expanded: boolean) => {
    setIsExpanded(expanded);
  };
  return (
    <Accordion
      header={<FeedbackItemHeader feedbackDetails={feedback} />}
      containerClassName="border-0 !border-b border-gray-300 hover:shadow-none rounded-none mb-5"
      headerClassName="ml-0 mr-0 !items-start !border-none "
      bodyClassName={`${isExpanded ? 'max-h-fit' : ''}`}
      onToggledExpansion={handleExpansion}
      headerArrowClassName="h-5 w-5"
      expanded={isExpanded}
    >
      <FeedbackItemBody feedbackDetails={feedback} />
    </Accordion>
  );
};

export default FeedbackAccordion;
